import { FC } from 'react'
import Strings from 'project/localisation'
import TitledAccordion from 'components/TitledAccordion'
import { membershipStrings } from 'common/strings/membership-strings' // we need this to make JSX compile

type MeetingRoomFeaturesSectionType = {}

const MeetingRoomFeaturesSection: FC<MeetingRoomFeaturesSectionType> = ({}) => {
  return (
    <div className='mt-8 pt-8'>
      <TitledAccordion
        items={[
          {
            body: membershipStrings.flexibleTermsDescription,
            title: membershipStrings.flexibleTerms,
          },
          {
            body: membershipStrings.wirelessEthernetDescription,
            title: membershipStrings.wirelessEthernet,
          },
          {
            body: membershipStrings.fullyEquippedDescription,
            title: membershipStrings.fullyEquipped,
          },
          {
            body: membershipStrings.ergonomicSeatingDescription,
            title: membershipStrings.ergonomicSeating,
          },
          {
            body: membershipStrings.communityManagerDescription,
            title: membershipStrings.communityManager,
          },
          {
            body: membershipStrings.airConditioningDescription,
            title: membershipStrings.airConditioning,
          },
          {
            body: membershipStrings.accessToMixerDescription,
            title: membershipStrings.accessToMixer,
          },
          {
            body: membershipStrings.keyFobDescription,
            title: membershipStrings.keyFob,
          },
          {
            body: membershipStrings.wetRoomDescription,
            title: membershipStrings.wetRoom,
          },
          {
            body: membershipStrings.fullServicedKitchenDescription,
            title: membershipStrings.fullServicedKitchen,
          },
          {
            body: membershipStrings.allUtilitiesIncludedDescription,
            title: membershipStrings.allUtilitiesIncluded,
          },
          {
            body: membershipStrings.filterCoffeeDescription,
            title: membershipStrings.filterCoffee,
          },
          {
            body: membershipStrings.turnUpPlugInDescription,
            title: membershipStrings.turnUpPlugIn,
          },
        ]}
        image={require('public/images/company-formation/crunch-page-registration-desktop.png')}
        title={membershipStrings.membershipAccess}
        imageAlt={`${Strings.membership} icon`}
        subtitle={`${membershipStrings.membershipAccessDescription}`}
        className={'offset-lg-2 ps-6 me-xxxl-n8'}
        paddingClasses={'pt-md-18'}
      />
    </div>
  )
}

export default MeetingRoomFeaturesSection
